import React from 'react';

import List from './operator/List'

function Operator(){
	return(
	
			<List/>
			
		
	);
}

export default Operator;